import type { Composer } from 'vue-i18n'
import { until } from '@vueuse/core'

export default defineNuxtPlugin({
  name: 'back-in-stock',
  setup(nuxtApp) {
    const notifications = useBackInStock()
    const auth = useAuth()
    const { locale } = nuxtApp.$i18n as Composer
    nuxtApp.hook('app:mounted', () => {
      notifications.restore()
      watch([() => auth.activeCustomer.value?.id, locale], async (_next, _previous, onCleanup) => {
        let cancelled = false
        onCleanup(() => {
          cancelled = true
        })
        notifications.clearCustomer()
        // An eager account refresh can resolve inside the click that initiated
        // login. Wait for that click once; watching `busy` itself would retry a
        // failed request indefinitely.
        if (notifications.busy.value)
          await until(notifications.busy).toBe(false)
        if (!cancelled)
          await notifications.completePending()
      }, { immediate: true })
    })
    nuxtApp.hook('auth:logout', () => {
      notifications.clearPending()
      notifications.clearCustomer()
    })
  },
})
